import React, {useEffect} from 'react'
import {FormInput, useInputValue} from '@modifi/plugin-forms'
import {InputPure, withInputContainer} from '@modifi/ui'
import {useTranslation} from '@modifi/plugin-i18n'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {usePrevious} from '../../hooks'

const InputPureWithContainer = withInputContainer(InputPure)

const propTypes = {
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  validationFunction: PropTypes.func,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  isSmall: PropTypes.bool,
  collapse: PropTypes.bool,
  required: PropTypes.bool,
}

const defaultProps = {
  label: undefined,
  placeholder: undefined,
  isSmall: false,
  collapse: false,
  required: false,
}

type FormInputCapitalizedProps = InferPropTypes<typeof propTypes, typeof defaultProps>

const FormInputCapitalized = ({
  name,
  placeholder,
  label,
  disabled,
  validationFunction,
  ...rest
}: FormInputCapitalizedProps) => {
  const {t} = useTranslation(['argus', 'plugin-forms'], {useSuspense: false})

  const {value, onChange} = useInputValue<string>({name})
  const previousValue = usePrevious(value)

  useEffect(() => {
    if (value !== previousValue) {
      const capitalized = value.toUpperCase()
      !!capitalized && onChange(capitalized)
    }
  }, [onChange, previousValue, value])

  return (
    <FormInput
      inputComponent={InputPureWithContainer}
      name={name}
      label={label}
      placeholder={placeholder}
      validationFunction={validationFunction}
      disabled={disabled}
      t={t}
      {...rest}
    />
  )
}

FormInputCapitalized.prototype = propTypes
FormInputCapitalized.defaultProps = defaultProps

export default FormInputCapitalized
